import { createTheme } from '@mui/material/styles';
import { esES as coreEsES } from '@mui/material/locale';

import darkThemeOptions from './dark-theme-options';
import lightThemeOptions from './light-theme-options';

const createCustomTheme = (themePreference: 'dark' | 'light') => {
  const theme = createTheme(
    themePreference === 'dark' ? darkThemeOptions : lightThemeOptions,
    coreEsES,
  );

  return theme;
};

export default createCustomTheme;
